import React from "react";
import PropTypes from "prop-types";
import { Label } from "../../Components/Label";
import { OptionIndex } from "../../Components/OptionIndex";
import { OptionFeedback } from "../../Components/OptionFeedback";
import { OptionWrapper } from "../../Components/OptionWrapper";

const SHAPE = "square";
/**
 * Option:
 *  - Option Component for MultiSelect Component
 */
export function Option(props) {
  const selectOption = () => {
    props.disabled === false &&
      props.selectOption({
        optionID: props.id,
        checked: !props.selected,
      });
  };

  const getOptionClassName = () => {
    if (props.selected && props.disabled && !props.isCorrect)
      return "mscq__option incorrect";
    else if (props.disabled && props.isCorrect) return "mscq__option correct";
    else if (props.disabled && !props.selected) return "mscq__option invalid";
    else if (props.selected) return "mscq__option selected";
    else return "mscq__option";
  };

  const getFeedbackClassName = () => {
    if (props.isCorrect) return "mscq__feedback_correct";
    else return "mscq__feedback_incorrect";
  };

  return (
    <>
      <OptionWrapper
        className={getOptionClassName()}
        selectOption={selectOption}
      >
        <OptionIndex
          id={props.id}
          index={props.index}
          shape={SHAPE}
          selected={props.selected}
          disabled={props.disabled}
          isCorrect={props.isCorrect}
        />
        <Label label={props.text} id={props.id} />
      </OptionWrapper>
      <OptionFeedback
        tabIndex={props.tabIndex}
        visible={props.disabled}
        className={getFeedbackClassName()}
        text={`<p>${props.isCorrect ? "Correct. " : "Not quite. "} ${props.feedback}</p>`}
      />
    </>
  );
}

Option.propTypes = {
  /**
   * Custom className to be set on component
   */
  className: PropTypes.string,
  /**
   * The feedback to be displayed for the particular option
   */
  feedback: PropTypes.string,
  /**
   * ID for the particular prop
   */
  id: PropTypes.number.isRequired,
  /**
   * Boolean value specifying if the option is correct
   */
  isCorrect: PropTypes.bool.isRequired,
  /**
   * Boolean value specifying if the option is selected
   */
  selected: PropTypes.bool,
  /**
   * Boolean value specifying if the option is disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function to be involked when selecting the option
   */
  selectOption: PropTypes.func.isRequired,
  /**
   * Option for the question are displayed here
   */
  text: PropTypes.string,
  /**
   * for keyboard navigation
   */
  tabIndex: PropTypes.string,
};

Option.defaultProps = { className: "" };
